
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/all",
      function () {
        return require("private-next-pages/brands/all.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/all"])
      });
    }
  